import { Injectable } from '@angular/core';
import { ColDef, ExcelCell, ExcelRow, ProcessRowGroupForExportParams } from 'ag-grid-community';

@Injectable({
  providedIn: 'root',
})
export class ExportGridService {
  exportExcelDetailDataBelowRow(params: ProcessRowGroupForExportParams): ExcelRow[] {
    // In order to access this class properties inside the export closure
    // we need to use params.context.componentParent (this word won't work)
    console.log('exportDetailDataBelowRow', params);
    const parent = params.context.componentParent;
    const detailColumnsToDisplay = parent.detailColumnsToDisplay;
    const detailData = params.node.data?.detailData;

    if (detailColumnsToDisplay && detailData) {
      const headerRow = parent.exportGridService.exportDetailDataHeader(detailColumnsToDisplay, parent);
      const dataRows = parent.exportGridService.exportDetailDataRows(detailData, detailColumnsToDisplay, parent);

      return headerRow.concat(...dataRows);
    }
    return undefined;
  }

  exportDetailDataHeader(detailColumns: ColDef[], parent: any): ExcelRow[] {
    const emptyHeaderCell = parent.exportGridService.newCell('header', 'String', '');
    return [
      {
        cells: [emptyHeaderCell].concat(
          detailColumns.map(function (column: ColDef) {
            return parent.exportGridService.newCell('agGridBenchmarkBackground', 'String', column.headerName);
          })
        ),
      },
    ];
  }

  exportDetailDataRows(detailData: any, detailColumns: ColDef[], parent: any): ExcelRow[] {
    const emptyBodyCell: ExcelCell = parent.exportGridService.newCell('body', 'String', '');
    return detailData.map(function (detailRow: any) {
      return [
        {
          cells: [emptyBodyCell].concat(
            detailColumns.map(function (column: ColDef) {
              const rawValue = detailRow[column.colId];
              const type = parent.exportGridService.getType(rawValue);
              const translatedValue = parent.exportGridService.getTranslatedValue(type, rawValue, parent);
              const styleId = parent.exportGridService.getStyleId(type, column.colId, rawValue);

              return parent.exportGridService.newCell(styleId, type, translatedValue ? translatedValue : rawValue);
            })
          ),
        },
      ];
    });
  }

  getType(rawValue: string): 'String' | 'Number' {
    return isNaN(Number(rawValue)) ? 'String' : 'Number';
  }

  getTranslatedValue(type: 'String' | 'Number', value: string, parent: any): string {
    if (type === 'String') {
      return parent.cService.getSingleTranslation(`REPORTDATA.${value}`, value);
    }

    return value;
  }

  getStyleId(type: 'String' | 'Number' | null, columnId: string, rawValue: string): string {
    if (type === 'String') {
      if (columnId === 'gicDamageType') {
        return `damageType${rawValue}`;
      }
    }

    return 'body';
  }

  newCell(styleId: string, type: 'String' | 'Number', value: string): ExcelCell {
    return {
      styleId,
      data: {
        type,
        value,
      },
    };
  }
}
